import { Toggle } from '../../toggle';
import React, * as react from 'react';

type PropsType = {
  className?: string;
  children: React.ReactNode;
  isExpanded?: boolean | undefined;
  getToggleProps?: {
    [k: string]: unknown;
    onClick?: react.MouseEventHandler<Element> | undefined;
    disabled?: boolean | undefined;
  } | null;
  onSwitch?: (() => void) | undefined;
  checked?: boolean | null;
  separator?: boolean | null;
  sup?: string | null;
};

export const Heading = ({
  className = '',
  children,
  isExpanded = undefined,
  getToggleProps = null,
  onSwitch,
  separator = null,
  checked = null,
  sup = null,
}: PropsType) => {
  const tw = {
    heading:
      'text-lg! leading-7! font-semibold! text-gray-900 flex' +
      (getToggleProps !== null ? ' w-full' : '') +
      (isExpanded
        ? ' flex-start'
        : onSwitch !== null
          ? ' justify-between items-center'
          : ''),
    rotate_animation: `transition-all ease-in-out duration-200 ${
      isExpanded ? '' : '-rotate-90'
    }`,
    switch: 'mt-0.5',
    separator:
      'border-t border-surface-2-stroke w-full mt-3 h-0 transition duration-150 ease-in-out ' +
      (isExpanded || separator ? '' : ' hidden mt-0'),
    sup: 'pl-1 text-gray-500 top-2.5 font-normal text-sm',
  };

  return (
    <div>
      <h2 className={tw.heading + ' ' + className}>
        <span {...getToggleProps} className={getToggleProps ? 'w-full' : ''}>
          {children}
          {sup && (
            <sup
              className="-top-2.5 pl-1 text-sm font-normal text-gray-500"
              aria-hidden={true}
            >
              {sup}
            </sup>
          )}
          {isExpanded !== undefined && (
            <span className="pl-2">
              <i className={'fas fa-caret-down ' + tw.rotate_animation} />
            </span>
          )}
        </span>

        {onSwitch !== undefined && (
          <div className={tw.switch}>
            <Toggle
              size="medium"
              state={checked ? 'on' : 'off'}
              onClick={(e: { stopPropagation: () => void }) =>
                e.stopPropagation()
              }
              onChange={onSwitch}
            />
          </div>
        )}
      </h2>
      {(isExpanded !== null || separator) && <div className={tw.separator} />}
    </div>
  );
};
